import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { FormBuilder } from '@angular/forms';
/*import { FormBuilder } from '@angular/forms';*/


@Injectable({
  providedIn: 'root'
})
export class FeesReceiptTempService {
  userData: string[][];
  //formData: Student = new Student();
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  baseURL_2 = 'https://localhost:44386/api';
  //constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'my-auth-token'
    }),
  };
  constructor(private formBuilder: FormBuilder, private http: HttpClient) {
    sessionStorage.setItem('NbaseURLs', 'https://www.eduinst.in/api/NStud');
    //sessionStorage.setItem('NbaseURLs', 'https://localhost:5001/api/NStud');
    //this.baseURL = sessionStorage.getItem('NbaseURLs');
  }

  
  AddFeeBillTemp(UserForm: any): Promise<any> {
    debugger;
    return new Promise((resolve, reject) => {
      this.http.post(this.baseURL + '/FeeBillTempSaveData', UserForm).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      });
    });
    //return this.http.post<any>(this.baseURL + '/FeeBillTempSaveData', UserForm);
  }

  DelRestoreFeeBillTemp(YearCode: number, TId: number, deleted: number): Promise<any> {
    debugger;
    return new Promise((resolve, reject) => {
      this.http.get(this.baseURL + '/DelRestoreFeeBillTemp?YearCode=' + YearCode + '&&TId=' + TId + '&&deleted=' + deleted).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      });
    });
    //return this.http.post<any>(this.baseURL + '/FeeBillTempSaveData', UserForm);
  }

  ViewLastFeeBillTempEntry(YearCode: number, TId: number): Observable<any> {
    return this.http.get<any>(this.baseURL + '/ViewLastFeeBillTempEntry?YearCode=' + YearCode + '&&BillNo=' + TId)
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewLastFeeBillTempEntryRange(YearCode: number, TId1: number, TId2: number): Promise<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewLastFeeBillTempEntryRange?YearCode=' + YearCode + '&&BillNo1=' + TId1 + '&&BillNo2=' + TId2)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  ViewAllFeeBillTempEntry(YearCode: number): Observable<any> {
    return this.http.get<any>(this.baseURL + '/ViewAllFeeBillTempEntry?YearCode=' + YearCode)
      .pipe(retry(1), catchError(this.handleError));
  }

  //ViewSelectedFeeBillTempEntry(YearCode: number, BillNo: number): Observable<any> {
  //  return this.http.get<any>(this.baseURL + '/ViewSelectedFeeBillTempEntry?YearCode=' + YearCode + '&&BillNo=' + BillNo)
  //    .pipe(retry(1), catchError(this.handleError));
  //}
  

  //AddStduentTranFeesAdjust(_formdata: any[], userInput: any[], userInputW: any[], _formtype: string, _usercode: string): Observable<any> {
  //  return this.http.get<any>(this.baseURL + '/AddStduentTranFeesDet?userInput=' + userInput.toString())
  //}

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }  
}
